// src/routes/PrivateRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ROUTE_PATHS } from "../config/constants";

const PrivateRoute = () => {
  const { isAuthenticated, initializing } = useAuth();

  if (initializing) {
    return <div>Loading...</div>;
  }

  // return isAuthenticated ? (
  //   <Outlet />
  // ) : (
  //   <Navigate to={ROUTE_PATHS.LOGIN} replace />
  // );
  return true ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTE_PATHS.LOGIN} replace />
  );
};

export default PrivateRoute;
